/* eslint-disable no-alert, no-console */
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { deleteV1UsersAddressesIdClient } from "./deleteV1UsersAddressesIdClient.ts";
import { deleteV1UsersMeDestroyClient } from "./deleteV1UsersMeDestroyClient.ts";
import { getV1UsersAddressesClient } from "./getV1UsersAddressesClient.ts";
import { getV1UsersAddressesIdClient } from "./getV1UsersAddressesIdClient.ts";
import { getV1UsersIdClient } from "./getV1UsersIdClient.ts";
import { getV1UsersMeClient } from "./getV1UsersMeClient.ts";
import { getV1UsersUserSettingsClient } from "./getV1UsersUserSettingsClient.ts";
import { postV1UsersAddressesClient } from "./postV1UsersAddressesClient.ts";
import { postV1UsersClient } from "./postV1UsersClient.ts";
import { putV1UsersAddressesIdClient } from "./putV1UsersAddressesIdClient.ts";
import { putV1UsersIdClient } from "./putV1UsersIdClient.ts";
import { putV1UsersUserSettingsClient } from "./putV1UsersUserSettingsClient.ts";

export function usersService() {
  return { postV1UsersClient, getV1UsersIdClient, putV1UsersIdClient, getV1UsersMeClient, deleteV1UsersMeDestroyClient, getV1UsersUserSettingsClient, putV1UsersUserSettingsClient, getV1UsersAddressesClient, postV1UsersAddressesClient, getV1UsersAddressesIdClient, putV1UsersAddressesIdClient, deleteV1UsersAddressesIdClient }
}